import Icon from '../components/Icon.vue'

Icon.register({
  'user-tag': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M630.6 364.9c12.5 12.5 12.5 32.7-0.1 45.2l-92.5 92.5c-12.5 12.5-32.8 12.5-45.3 0l-90.3-90.2c-12-12-18.7-28.2-18.7-45.2v-79.2c0-17.7 14.3-32 32-32h79.3c17 0 33.3 6.7 45.3 18.7zM447.8 343.9c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 13.3 10.7 24 24 24zM224 255.9c-70.7 0-128-57.3-128-127.9 0-70.7 57.3-128 128-128s128 57.3 128 127.9c0 70.7-57.3 128-128 128zM351.8 367.1c0 25.7 10 49.8 28.1 67.9l58 58c-8.8 11.4-22.4 18.9-37.9 18.9h-352c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.5h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7c13.3 0 26 2.6 38.2 6.2v73.1z'
      }
    ]
  }
})
